import { render, staticRenderFns } from "./customer_transfer.vue?vue&type=template&id=72d4ebf1&scoped=true&"
import script from "./customer_transfer.vue?vue&type=script&lang=js&"
export * from "./customer_transfer.vue?vue&type=script&lang=js&"
import style0 from "./customer_transfer.vue?vue&type=style&index=0&id=72d4ebf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d4ebf1",
  null
  
)

export default component.exports